/* eslint-disable @typescript-eslint/no-explicit-any */
import { Tools } from '@/@corefabriccanvas';
import {
  CropIcon,
  EraserIcon,
  HandIcon,
  MarkerIcon,
  PenIcon,
  SelectIcon,
  ShapesIcon,
  TrashIcon,
  ZoomInIcon,
  ZoomOutIcon,
} from '@/icons';
import { EraserShortCuts, PageItemPosition } from '@/types';

export interface ToolItem {
  name: Tools;
  icon: any;
  title: string;
}

export const tools: ToolItem[] = [
  {
    name: Tools.Pan,
    icon: <HandIcon className={undefined} />,
    title: 'Taşı',
  },
  {
    name: Tools.Select,
    icon: <SelectIcon className={undefined} />,
    title: 'Seç',
  },
  {
    name: Tools.Pencil,
    icon: <PenIcon className={undefined} />,
    title: 'Seç',
  },
  {
    name: Tools.Marker,
    icon: <MarkerIcon className={undefined} />,
    title: 'İşaretle',
  },
  {
    name: Tools.Eraser,
    icon: <EraserIcon className={undefined} />,
    title: 'Silgi',
  },
  {
    name: Tools.Crop,
    icon: <CropIcon className={undefined} />,
    title: 'Kırp',
  },
  {
    name: Tools.Shapes,
    icon: <ShapesIcon className={undefined} />,
    title: 'Şekiller',
  },
  {
    name: Tools.Trash,
    icon: <TrashIcon className={undefined} color={undefined} />,
    title: 'Temizle',
  },
  {
    name: Tools.ZoomIn,
    icon: <ZoomInIcon className={undefined} />,
    title: 'Yaklaş',
  },
  {
    name: Tools.ZoomOut,
    icon: <ZoomOutIcon className={undefined} />,
    title: 'Uzaklaş',
  },
];

export const getPageItemPositionOptions = (t: any) => {
  const positionButtons = [
    { label: t('content_position_left'), value: PageItemPosition.left },
    { label: t('content_position_center'), value: PageItemPosition.center },
    { label: t('content_position_right'), value: PageItemPosition.right },
  ];

  return positionButtons;
};

export const getPageNavigationOptions = (t: any) => {
  const pageNavigationOptions = [
    { label: t('yes'), value: true },
    { label: t('no'), value: false },
  ];

  return pageNavigationOptions;
};

export const getSaveDrawingOptions = (t: any) => {
  const saveDrawingOptions = [
    { label: t('save'), value: true },
    { label: t('dontSave'), value: false },
  ];

  return saveDrawingOptions;
};

export const getEraserOptions = (t: any) => {
  const eraserShortCuts = [
    { label: t('eraser_shortcut_closed'), value: EraserShortCuts.Closed },
    { label: t('eraser_shortcut_longpress'), value: EraserShortCuts.LongPress },
    { label: t('eraser_shortcut_doubletap'), value: EraserShortCuts.DoubleTap },
  ];

  return eraserShortCuts;
};

export const getContinueLastPageOptions = (t: any) => {
  const continueLastPageOptions = [
    { label: t('yes'), value: true },
  { label: t('no'), value: false },
  ];

  return continueLastPageOptions;
};

export const getHideIconsOptions = (t: any) => {
  const hideIconOptions = [
    { label: t('yes'), value: true },
  { label: t('no'), value: false },
  ];

  return hideIconOptions;
};


export const getToolBoxAutoMoveOptions = (t: any) => {
  const toolBoxMoveOptions = [
    { label: t('yes'), value: true },
  { label: t('no'), value: false },
  ];

  return toolBoxMoveOptions;
};
